// extracted by mini-css-extract-plugin
module.exports = {"CompletedMessage":"CompletedMessage_CompletedMessage__2_PMH","Close":"CompletedMessage_Close__1YMLs","BeforeCompletedMessage":"CompletedMessage_BeforeCompletedMessage__3u6HP"};